import { helperServices } from "../../shared/helper";
import history from "../../shared/utils/history";
import { apiFetch } from "../../shared/helper/apiFetch";

const basePath = "api/v2";
const v1basePath = "api/v1";

// -------------------- Logout --------------------
function logout() {
  localStorage.removeItem("user");
  history.push("/");
  window.location.reload();
}

// -------------------- Handle Response --------------------
function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    const token = response.headers.get("Authorization");

    if (token) {
      localStorage.setItem("token", JSON.stringify(token));
    }

    if (!response.ok) {
      if (response.status === 401) {
        logout(); 
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

// -------------------- Helper: Build Headers --------------------
function buildHeaders() {
  const accessToken = helperServices.getAuthorization() || "";
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
}

// ---------------------Get userCollection Details --------------------
function getUserCollectionDetails (data) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/user/collections/details?person=${data.person}&startDate=${data.startdate}&endDate=${data.enddate}`;
  return apiFetch(url, requestOptions);
}

// -------------------- Get userCollection Summary --------------------
function getUserCollectionSummary (data) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/user/collections/summary?person=${data.person}&startDate=${data.startdate}&endDate=${data.enddate}`;
  return apiFetch(url, requestOptions);
}


// -------------------- Get service Revenue Report--------------------
function getserviceRevenueReport(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };

  const url = `${basePath}/user/report/service/revenue`;
  return apiFetch(url, requestOptions);
}

// -------------------- Get Bill Summary Report--------------------
function getBillSummaryReport(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };

  const url = `${basePath}/user/report/bill/summary`;
  return apiFetch(url, requestOptions);
}

// -------------------- Get Bill Revenue Report--------------------
function getBillRevenueReport(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };

  const url = `${basePath}/user/report/bill/revenue`;
  return apiFetch(url, requestOptions);
}


// -------------------- Get Doctor Report--------------------
function getDoctorReport(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };

  const url = `${basePath}/user/report/doctor/service`;
  return apiFetch(url, requestOptions);
}

// -------------------- Get Category List--------------------
function getCategoryList (data) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/user/report/filter/category`;
  return apiFetch(url, requestOptions);
}

function downloadBackup(data) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${v1basePath}/create_Backup`;
  return apiFetch(url, requestOptions);
}
function getPatientJourneyReport(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/user/report/patient/journey`;
  return apiFetch(url, requestOptions);
}

const collectionSummaryServices = {
  logout,
  handleResponse,
  getUserCollectionSummary,
  getUserCollectionDetails,
  getserviceRevenueReport,
  getBillSummaryReport,
  getBillRevenueReport,
  getCategoryList,
  downloadBackup,
  getDoctorReport,
  getPatientJourneyReport
};

export default collectionSummaryServices;

